<div class="enterprise-dashboard" *ngIf="ENTPDetails">

  <!-- HEADER -->
  <div class="header-card">
    <div>
      <h2>{{ ENTPDetails.enterpriseName }}</h2>
      <p class="sub-text">{{ ENTPDetails.enterpriseType }} Enterprise</p>
    </div>

    <span
      class="status"
      [class.active]="ENTPDetails.isActive === 1"
      [class.inactive]="ENTPDetails.isActive !== 1">
      {{ ENTPDetails.isActive === 1 ? 'Active' : 'Inactive' }}
    </span>
  </div>
  


  <!-- OVERVIEW -->
  <div class="overview-grid">
    <div class="overview-card">
      <label>Company Code</label>
      <h3>{{ ENTPDetails.companyCode }}</h3>
    </div>

    <div class="overview-card">
      <label>Total Trips</label>
      <h3>{{ ENTPDetails.noOfTrips }}</h3>
    </div>

    <div class="overview-card">
      <label>Frequency</label>
      <h3>{{ ENTPDetails.frequency | titlecase }}</h3>
    </div>

    <div class="overview-card">
      <label>Type</label>
      <h3>{{ ENTPDetails.enterpriseType }}</h3>
    </div>
  </div>

    <app-trip-analytics></app-trip-analytics>
  <!-- BASIC INFO -->
  <div class="card mt-4">
    <h4>Enterprise Details</h4>
    <div class="info-grid">
      <div><label>Email</label><p>{{ ENTPDetails.email }}</p></div>
      <div><label>Phone</label><p>{{ ENTPDetails.phone }}</p></div>
      <div><label>GST Number</label><p>{{ ENTPDetails.gstNumber }}</p></div>
      <div><label>PAN</label><p>{{ ENTPDetails.pancardNumber }}</p></div>
    </div>
  </div>

  <!-- ADDRESS -->
  <div class="card">
    <h4>Address</h4>
    <p>
      {{ ENTPDetails.address }},
      {{ ENTPDetails.city }},
      {{ ENTPDetails.state }}
    </p>
  </div>

  <!-- BANK DETAILS -->
  <div class="card">
    <h4>Bank & Payment Details</h4>
    <div class="info-grid">
      <div><label>UPI ID</label><p>{{ ENTPDetails.upiId }}</p></div>
      <div><label>Bank Name</label><p>{{ ENTPDetails.bankName }}</p></div>
      <div><label>Account Number</label><p>{{ ENTPDetails.bankAccountNumber }}</p></div>
      <div><label>IFSC</label><p>{{ ENTPDetails.bankIfscCode }}</p></div>
    </div>

    <div class="qr-section" *ngIf="ENTPDetails.qrCode">
      <label>QR Code</label><br />
      <img [src]="ENTPDetails.qrCode" alt="QR Code" />
    </div>
  </div>

  <app-trips></app-trips>

</div>
